import axios from 'axios'
import { GetCookie, SetCookie, RemoveCookie } from './CookieService'
import functions from './functions'

const axiosInstance = axios.create({})

export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME
export const NOT_AUTH = process.env.REACT_APP_NOT_AUTH
export const EXPIRY_PASS = process.env.REACT_APP_EXPIRY_PASS
export const CACHE_ROUTE = process.env.REACT_APP_CACHE_ROUTE

export const ApiService = (process_code, data) => {
    return sendApiService('POST', '/api/v1/front/process', data, process_code);
}

export const sendApiService = (method, url, data, process_code) => {
    const options = {
        method: method,
        url,
        ...(data?._download && { responseType: 'blob' }),
        headers: {
            'Content-Type': 'application/json', //'application/octet-stream'
            'Access-Control-Allow-Origin': '*',
            Authorization: 'Bearer ' + GetCookie(TOKEN_NAME),
            'pc': process_code,
            'language': localStorage.getItem('i18nextLngMeCoreBack') || 'mn'
        }
    }

    if (process_code !== "lo000002") {
        localStorage.setItem('sessionTimer', new Date());
    }

    options.data = data;
    const onSuccess = function (response) {
        // if (basicOptions !== null) return response
        RemoveCookie(NOT_AUTH);
        if (data?._download) {
            return response.data;
        }
        if (response?.data && response?.data.response_code) {
            if (response.data.response_code === "RC000000"
                || response.data.response_code === "RC000110") {
                let data = response.data.response;
                if (data) {
                    if (!data.total) {
                        if (data.next_page_url) {
                            data.total = data.to + 1;
                        } else if (data.prev_page_url) {
                            data.total = data.to;
                        } else if (data.data) {
                            data.total = data.data?.length;
                        }
                    }
                    if (data.custmsg && data.custmsg.length > 0) {
                        localStorage.setItem('ME_CUSTMSGDATA', JSON.stringify({ show: true, data: data.custmsg }));
                    }
                }
                return data;
            }
        }

        return Promise.reject(response)

    }

    const onError = function (error) {
        if (error.data && error.data.response) {
            if (error.data.response_code === 'RC000006' || error.data.response_code === 'RC000265') {
                if (!GetCookie(NOT_AUTH)) {
                    const path = window.location.pathname;
                    if (path !== '/' && path !== '/login' && path !== '/register' && !path.includes("resetPassword")
                        && !path.includes("reset-password") && !path.includes("forgotpassword") && !path.includes("forgot-password")) {
                        SetCookie(CACHE_ROUTE, path);
                        window.location = '/login';
                    }
                }
                SetCookie(NOT_AUTH, 401);
            } else if (error.data.response_code === 'RC000169') {
                const path = window.location.pathname;
                if (path !== '/changePassword') {
                    window.location.replace('/changePassword');
                    SetCookie(EXPIRY_PASS, 303);
                }
            }

            return Promise.reject(error.data.response)
        }

        if (data?._download) {
            error.response = { data: 'Файл татахад алдаа гарлаа.' }
        }
        return Promise.reject(functions.getInfoRespError(error.response || error.message))
    }

    return axiosInstance(options).then(onSuccess).catch(onError)
}
